<template>
  <e-card @toggleDrag="$emit('toggleDrag')" :class="sizeClasses">
    <b-tab title="Activity & Rewards">
      <eb-chat></eb-chat>
    </b-tab>
  </e-card>
</template>

<script>
	import EbChat from "@components/widgets/chat/chat";
  import ECard from "../../elements/card/card";
  import DynamicSizeMixin from '../../../mixins/dynamicSize';

  export default {
		name: "ec-chat",
    mixins: [DynamicSizeMixin],
    components: {ECard, EbChat}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/chat/chat.vue